/* eslint-disable */
import { phoneTypes } from '@ringcentral-integration/commons/enums/phoneTypes';
export default {
  [phoneTypes.business]: '勤務先電話',
  [phoneTypes.extension]: '内線番号',
  [phoneTypes.home]: '自宅の番号',
  [phoneTypes.mobile]: '携帯電話',
  [phoneTypes.phone]: '電話',
  [phoneTypes.unknown]: '電話タイプが不明',
  [phoneTypes.company]: '会社の代表番号',
  [phoneTypes.direct]: 'ダイレクトナンバー',
  [phoneTypes.contact]: '電話で連絡',
  [phoneTypes.fax]: 'FAX',
  [phoneTypes.other]: 'その他',
};

// @key: @#@"[phoneTypes.business]"@#@ @source: @#@"Business Phone"@#@
// @key: @#@"[phoneTypes.extension]"@#@ @source: @#@"Extension Number"@#@
// @key: @#@"[phoneTypes.home]"@#@ @source: @#@"Home Number"@#@
// @key: @#@"[phoneTypes.mobile]"@#@ @source: @#@"Mobile Phone"@#@
// @key: @#@"[phoneTypes.phone]"@#@ @source: @#@"Phone"@#@
// @key: @#@"[phoneTypes.unknown]"@#@ @source: @#@"Unknown Phone Type"@#@
// @key: @#@"[phoneTypes.company]"@#@ @source: @#@"Company Number"@#@
// @key: @#@"[phoneTypes.direct]"@#@ @source: @#@"Direct Number"@#@
// @key: @#@"[phoneTypes.contact]"@#@ @source: @#@"Contact Phone"@#@
// @key: @#@"[phoneTypes.fax]"@#@ @source: @#@"Fax"@#@
// @key: @#@"[phoneTypes.other]"@#@ @source: @#@"Other"@#@
